import {
  DeleteDTO,
  useDeleteMutationFactory,
  UseDeleteMutationProps,
} from '@/lib/react-query/delete';
import { Inspection, InspectionLog } from '@/types';
import { remove } from '@/utils/api';
import { featureKeys, featurePath, InspectionLogSearchParams } from '.';

export type DeleteInspectionLogDTO = { inspection: Inspection } & DeleteDTO<
  InspectionLog,
  InspectionLogSearchParams
>;

const deleteInspectionLog = ({ inspection, id, data, params }: DeleteInspectionLogDTO) =>
  remove(`${featurePath(inspection)}/${id}`);

export const useDeleteInspectionLog = (options?: UseDeleteMutationProps<InspectionLog>) => {
  return useDeleteMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: deleteInspectionLog,
    ...options,
  });
};
